import React, { Fragment, useState, useEffect, useContext } from "react";
import GlobalContext from "../../providers/GlobalProvider";
import axios from "axios";
import TableComponent from "../Table/TableComponent";
import Loading from "../Loading";

export default function Vendor() {
  const [data, setServerData] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  /**
   * @type {GlobalContextValue}
   */
  const { defaultMapper } = useContext(GlobalContext);

  function getVendor() {
    let url = "/api/Vendor";
    axios
      .get(url)
      .then((result) => {
        setServerData(result.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }

  useEffect(() => {
    getVendor();
  }, [defaultMapper]);

  const handleSave = (vendorMatchingItem) => {
    let url = "/api/vendor";
    return axios
      .post(url, vendorMatchingItem)
      .then((result) => {
        console.log("Data saved successfully:", result);
        setTimeout(() => {
          setSuccess("Data saved successfully!");
        }, 1000);
        setError("");

        return result.data;
      })
      .catch((error) => {
        // if (error.response && error.response.status === 409) {
        if (error.response) {
          // setError(error.response.data + "");
          setError(error.message);
          setSuccess("");
        } else {
          setTimeout(() => {
            setError("Error saving data.");
          }, 1000);
          setSuccess("");
        }
        console.error(
          "Error saving data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  const handleUpdate = (matching) => {
    let url = "/api/Client";
    return axios
      .post(url, matching)
      .then((result) => {
        console.log("Data saved successfully:", result);
        setTimeout(() => {
          setSuccess("Data saved successfully!");
        }, 1000);
        setError("");
        window.location.reload();
        return result.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          setError(error.response.data + "");
          setSuccess("");
        } else {
          setTimeout(() => {
            setError("Error saving data.");
          }, 1000);
          setSuccess("");
        }
        console.error(
          "Error saving data:",
          error.response ? error.response.data : error.message
        );
      });
  };

  function handleDelete(matching) {
    console.log("delete matching: ", matching);
    let url = `/api/vendor/${matching.opsId}`;
    axios
      .delete(url)
      .then((response) => {
        setSuccess("Data Deleted Successfully!");

        setError("");
        setTimeout(() => {
          setSuccess("");
          window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        console.error("Error deleting item:", error);
      });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Fragment>
      <TableComponent
        columnTitle="Vendor"
        opsArray={data.vendors}
        opsIdProperty="id"
        opsDisplayProperty="name"
        accountingArray={data.people}
        accountingIdProperty="pid"
        accountingDisplayProperty="name"
        branchArray={data.branches}
        branchIdProperty="id"
        branchDisplayProperty="latinName"
        accCurrArray={data.accountsCurrencies}
        accCurrIdProperty="accountID"
        accCurrDisplayProperty="acc_num"
        existingMatches={data.matches}
        matchingOpsIdProperty="opsId"
        matchingLibraIdProperty="auxiliaryId"
        matchingBranchIdProperty="branchId"
        matchingAccCurrCode="accountCurrencies"
        handleSave={handleSave}
        handleUpdate={handleUpdate}
        handleDelete={handleDelete}
      />
      <h5 style={{ color: "red" }}>{error}</h5>
      <h5 style={{ color: "green" }}>{success}</h5>
    </Fragment>
  );
}
